import type { ProfileBadge } from '@/types/qriots';
import { cn } from '@/lib/cn';

const TIER_COLORS: Record<ProfileBadge['tier'], string> = {
  gold: 'bg-brand/15 text-brand',
  silver: 'bg-fg-muted/10 text-fg',
  bronze: 'bg-warning/15 text-warning',
  neutral: 'bg-bg-tertiary text-fg-muted',
};

interface BadgeChipProps {
  badge: ProfileBadge;
  size?: 'sm' | 'md';
}

export function BadgeChip({ badge, size = 'md' }: BadgeChipProps) {
  return (
    <span
      title={badge.description}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-medium',
        TIER_COLORS[badge.tier],
        size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs',
      )}
    >
      <span aria-hidden>{badge.emoji}</span>
      <span>{badge.label}</span>
    </span>
  );
}
